<dialog-gala (clickClose)="hideModalFonction()">
    <span gala-dialog-titre>{{(fonction) ? lgTradFct.MODIFFCT : lgTradFct.CREAFCT }}</span>
    <form [formGroup]="formFonction" autocomplete="off">
        <div class="container">
            <br />
            <div class="row">
                <div class="col-6">
                    <select-gala formControlName="TYPEFCT" [options]="types" [label]="lgTradFct.TYPE"
                        [disabled]="!droitsAccess.write" bindValue="value" bindLabel="label" />
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <select-gala [disabled]="(fonction != null)? true : false" [searchable]="true"
                        formControlName="FONCTION" [options]="listeFONCTION" [label]="lgTradFct.FONCTION"
                        bindValue="IDFONCTION" bindLabel="FONCTION" />
                </div>
                <div class="col-6">
                    <select-gala [disabled]="(fonction != null)? true : false" [searchable]="true"
                        formControlName="ORGANISME" [options]="listeORGA" [label]="lgTradFct.ORGANISME"
                        bindValue="IDORGA" bindLabel="NOM" />
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <input-gala formControlName="ETP" [label]="'ETP (en %)'"
                        (keydown)="util.lengthLessThan($event,3) && util.acceptOnlyNumber($event)" />
                </div>
                <div class="col-6">
                    <input-gala formControlName="COOCTAGRI" [label]="lgTradFct.OCTAGRICODE" />
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <date-gala [label]="lgTradFct.DEBUT" [placeholder]="lgTradFct.BEGINNINGDATE"
                        formControlName="DDEBUT" />
                </div>
                <div class="col-6">
                    <date-gala [label]="lgTradFct.FIN" [placeholder]="lgTradFct.ENDDATE"
                        formControlName="DFIN" />
                </div>
            </div>
        </div>
    </form>
    <div gala-dialog-actions>
        <button mat-stroked-button color="primary" (click)="addFonction()">{{lgTrad.ENR}}</button>
        <button mat-stroked-button color="accent" (click)="hideModalFonction()">{{lgTrad.RET}}</button>
    </div>
</dialog-gala>